// import './build/three.js';
// import './build/three.module.js';
// import './js/nodes/THREE.Nodes.js';
// import './js/objects/Reflector.js';
// import './js/objects/ReflectorRTT.js';
// import './js/loaders/NodeMaterialLoader.js';
// import './js/controls/OrbitControls.js';
// import './js/controls/TransformControls.js';
import {Ammo} from 'three/examples/js/libs/ammo.wasm.js';
import * as THREE from 'three/build/three.module';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { TransformControls } from 'three/examples/jsm/controls/TransformControls';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry';
import { Line2 } from 'three/examples/jsm/lines/Line2';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass.js';
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';
import { o2animation } from './animation.js';

import { Reflector } from 'three/examples/jsm/objects/Reflector.js';
//import { JSZip } from 'jszip/dist/jszip.min.js';
import * as JSZip from 'jszip'
var idx=0;


class o2vr
{
    constructor()
    {
        this.script={};
        this.cameras=[];
        this.animation = new o2animation;
        this.animation.o2=this;
        this.camera_switch_count=0;
    }
    switch_camera = (x,y,z,xx,yy,zz)=>
    {
        this.switch_camera2(x,y,z,xx,yy,zz);
        // this.camera_target = new THREE.Vector3(x,y,z);
        // this.camera_eye = new THREE.Vector3(xx,yy,zz);
        // this.camera_switch_count=100;
    }
    switch_camera2 = (x,y,z,xx,yy,zz)=>
    {
        this.camera_target2 = new THREE.Vector3(x,y,z);
        this.camera_eye2 = new THREE.Vector3(xx,yy,zz);
        this.begin_target2 = this.cameraControls.target.clone();
        this.begin_eye2 = this.camera.position.clone();
        this.camera_switch_count2=100;
    }
    ray_test=(event)=>
    {
        let mouse = new THREE.Vector2();
        mouse.x = (event.offsetX / this.WIDTH) * 2 - 1;
        mouse.y = - (event.offsetY / this.HEIGHT) * 2 + 1;
        let raycaster = new THREE.Raycaster();
        raycaster.setFromCamera(mouse, this.camera);
        var intersects = raycaster.intersectObjects(this.scene.children,true);
        return intersects;
    }
    
    ray_test2=(object,event)=>
    {
        let mouse = new THREE.Vector2();
        mouse.x = (event.offsetX / this.WIDTH) * 2 - 1;
        mouse.y = - (event.offsetY / this.HEIGHT) * 2 + 1;
        let raycaster = new THREE.Raycaster();
        raycaster.setFromCamera(mouse, this.camera);
        var intersects = raycaster.intersectObjects(object,true);
        return intersects;
    }

    animate=()=>
    {
        requestAnimationFrame(this.animate);
        

        if (this.camera_switch_count>0)
        {
            this.camera_switch_count-=1;
            this.cameraControls.target.lerp(this.camera_target,0.05);
            this.camera.position.lerp(this.camera_eye,0.05);
            if (this.camera_switch_count==0)
            {
                this.cameraControls.target.set(this.camera_target.x,this.camera_target.y,this.camera_target.z);
                this.camera.position.set(this.camera_eye.x,this.camera_eye.y,this.camera_eye.z);
            }
        }
        if (this.camera_switch_count2>0)
        {
            this.camera_switch_count2-=1;
            let target = this.begin_target2.clone();
            let eye = this.begin_eye2.clone();
            let alpha = 1-this.camera_switch_count2/100;
            
            let ease = -100;
            if (ease!=0)
            {
                let p = Math.exp(Math.abs(ease/100.0));
                if (ease<0)
                {
                    alpha=1-Math.pow((1-alpha),p);
                } else
                {
                    alpha=Math.pow(alpha,p);
                }
            }

            target.lerp(this.camera_target2,alpha);
            eye.lerp(this.camera_eye2,alpha);
            this.cameraControls.target.set(target.x,target.y,target.z);
            this.camera.position.set(eye.x,eye.y,eye.z);
        }
        let time2 = Date.now();
        let time_passed = (time2-this.last_time)/1000;
        if (time_passed>0.1) time_passed=0.1;//间隔不要超过0.1秒
        
        if (this.script&&this.script["frame_move"])
        {
            this.script["frame_move"](time_passed);
        }
        this.last_time=time2;
        this.animation.frame_move(time_passed);
        this.cameraControls.update();
        this.render();
        if (this.div_bind.length>0)
        {
            let viewMatrix = new THREE.Matrix4;
            let viewProjectionMatrix = new THREE.Matrix4;
            viewMatrix.copy( this.camera.matrixWorldInverse );
            viewProjectionMatrix.multiplyMatrices( this.camera.projectionMatrix, viewMatrix );
            
            for (let i=0;i<this.div_bind.length;i++)
            {
                let bind = this.div_bind[i];
                let pos = bind.position.clone();
                pos.applyMatrix4(viewProjectionMatrix);
                pos.x = pos.x*this.WIDTH/2+this.WIDTH/2;
                pos.y = this.HEIGHT/2-pos.y*this.HEIGHT/2;
                bind.div.style.position='absolute';
                let posx = Math.round(pos.x);
                let posy = Math.round(pos.y);
                bind.div.style.left=posx.toString()+"px";
                bind.div.style.top=posy.toString()+"px";
            }
        }
    }

    new_object=(obj)=>
    {
        if (obj.guid)
        {
            var obj3 = new THREE.Object3D();
            obj3.guid = obj.guid;
            this.objects[obj.guid]=obj;
        }
    }
    select_object=(obj)=>
    {
        if (obj.guid)
        {
            var obj3 =this.objects[obj.guid];
            if (obj3)
            {
                this.enable_gizmo(obj3);
            }
        }
    }
    load_mesh_data = (geometry,saved_object)=>
    {
        let o2=this;
        geometry.meshid=saved_object.meshid;
        let map = o2.map_white;
        if (saved_object.material.map&&saved_object.material.map.name!="")
        {
            map= o2.create_map(saved_object.material.map.name);
            map.offset.set(saved_object.material.map.offset.x,saved_object.material.map.offset.y);
            map.repeat.set(saved_object.material.map.repeat.x,saved_object.material.map.repeat.y);
            map.rotation=saved_object.material.map.rotation;
            map.wrapS = THREE.RepeatWrapping;
            map.wrapT = THREE.RepeatWrapping;
        }
        let map2 = o2.map_white;
        if (saved_object.material.lightMap)
        {
            map2= o2.create_map(saved_object.material.lightMap.name);
            map2.offset.set(saved_object.material.lightMap.offset.x,saved_object.material.lightMap.offset.y);
            map2.repeat.set(saved_object.material.lightMap.repeat.x,saved_object.material.lightMap.repeat.y);
        }
        let material = new THREE.MeshPhongMaterial( { map: map,lightMap:map2} );
        let mtl = saved_object.material;
        material.uuid = mtl.uuid;
        material.side = mtl.side;
        material.transparent = mtl.transparent;
        if (mtl.opacity) material.opacity=mtl.opacity;
        material.depthTest=mtl.depthTest;
        material.depthWrite=mtl.depthWrite;
       // mtl.reflectivity=0;
        if (mtl.type=="MeshPhongMaterial")
        {
            material.color.setHex(mtl.color);
            if (mtl.combine!=null) material.combine=mtl.combine;
            if (mtl.reflectivity!=null) material.reflectivity=mtl.reflectivity;
            if (mtl.lightMapIntensity!=null) material.lightMapIntensity=mtl.lightMapIntensity;
            if (mtl.emissiveIntensity!=null) material.emissiveIntensity = mtl.emissiveIntensity;
            if (saved_object.material.alphaMap!=null)  material.alphaMap = o2.create_map(saved_object.material.alphaMap.name)
            if (saved_object.material.emissiveMap!=null)  material.emissiveMap = o2.create_map(saved_object.material.emissiveMap.name)
            if (saved_object.material.normalMap!=null)  material.normalMap = o2.create_map(saved_object.material.normalMap.name)
            if (saved_object.material.specularMap!=null)  material.specularMap = o2.create_map(saved_object.material.specularMap.name)
            material.specular.setHex(mtl.specular);
            material.emissive.setHex(mtl.emissive);
            if (mtl.shininess) material.shininess=mtl.shininess;
            material.needsUpdate=true;
        }
        if (mtl.blending) material.blending=mtl.blending;
        
        material.o2id=mtl.o2id;
        o2.materials.push({id:material.o2id,mtl:material});
        material.envMap=o2.create_envMap(mtl.envMap);
        var mesh =  new THREE.Mesh(geometry,material);
        
        mesh.castShadow=saved_object.castShadow;
        mesh.receiveShadow=saved_object.receiveShadow;

        mesh.matrixWorldNeedsUpdate=true;
        mesh.name=saved_object.name;
        mesh.uuid=saved_object.uuid;
        var mat = saved_object.wts;
        mesh.applyMatrix4(mat);
        mesh.visible=saved_object.visible;
        return mesh;
    }
    load_saved_object = (saved_object) =>
    {
        let o2=this;
        return new Promise((resolve,reject) => {
            if (saved_object.type=="Mesh")
            {
                if (o2.from_zip)
                {
                    let xxx = this.all_files[saved_object.meshid];
                    let geometry = o2.load_mesh2(xxx);
                    if (geometry)
                    {
                        let mesh = o2.load_mesh_data(geometry,saved_object);
                        resolve(mesh);
                    }else{
                        reject("create geo fail!");
                    }
                }else{
                    let mdl_url = o2.project_url+saved_object.meshid;
                    let xhr = new XMLHttpRequest();
                    xhr.open("get", mdl_url, true);
                    xhr.responseType = "arraybuffer";
                    xhr.send();
                    xhr.onreadystatechange = () => {
                        if (xhr.readyState === 4) {
                            if (xhr.status >= 200 && xhr.status < 300) {
                                var xxx = xhr.response;
                                let geometry = o2.load_mesh2(xxx);
                                if (geometry)
                                {
                                    let mesh = o2.load_mesh_data(geometry,saved_object);
                                    resolve(mesh);
                                }else{
                                    reject("create geo fail!");
                                }
                            }
                            else {
                                reject(xhr.status);
                            }
                        }
                    }    
                } 
            } 
            else if (saved_object.type=="Object3D"){
                
                let obj =  new THREE.Object3D();
                obj.matrixWorldNeedsUpdate=true;
                obj.name=saved_object.name;
                obj.uuid=saved_object.uuid;
                let mat = saved_object.wts;
                obj.applyMatrix4(mat);
                obj.visible=saved_object.visible;
                if (saved_object.children&&saved_object.children.length>0)
                {
                    const allRequest = [];    
                    if (1) {
                        var mdls = saved_object.children;
                        for (let index = 0; index < mdls.length; index++) {
                            const model_obj = mdls[index];
                            var promise = o2.load_saved_object(model_obj);
                            promise.then((obj3)=> {
                                if (obj3) obj.add(obj3);
                            });
                            allRequest.push(promise);
                        }
                        Promise.all(allRequest).then(() => {
                            resolve(obj);
                        },() => {
                            reject()
                        })
                    }
                }else{
                    resolve(obj);
                }
           }
           else if (saved_object.type=="Sprite"){
            let mtl = saved_object.material;
            let map=null;
            if (mtl.map)
            {
                map = o2.create_map(mtl.map.name);
            }
            if (map==null)
            {
                map=o2.map_white;
            }
            
            let sprite = new THREE.Sprite( new THREE.SpriteMaterial( {map:map, color: '#69f' } ) );
            sprite.material.color.setHex(mtl.color);
            if (mtl.opacity) sprite.material.opacity=mtl.opacity;
            sprite.position.set(saved_object.position.x,saved_object.position.y,saved_object.position.z);
            sprite.scale.set(saved_object.scale.x,saved_object.scale.y,saved_object.scale.z);
            sprite.uuid=saved_object.uuid;
            sprite.name=saved_object.name;
            sprite.visible=saved_object.visible;
            resolve(sprite);
          }
            else if (saved_object.type=="AmbientLight"){

                let obj1 =  new THREE.AmbientLight(saved_object.color);
                obj1.intensity=saved_object.intensity;
                obj1.matrixWorldNeedsUpdate=true;
                obj1.name=saved_object.name;
                obj1.uuid=saved_object.uuid;
                let mat = saved_object.wts;
                obj1.applyMatrix4(mat);
                obj1.visible=saved_object.visible;    
                resolve(obj1);
            }
            else if (saved_object.type=="DirectionalLight"){

                let obj1 =  new THREE.DirectionalLight(saved_object.color, 0.5);
                obj1.intensity=saved_object.intensity;
                obj1.matrixWorldNeedsUpdate=true;
                obj1.name=saved_object.name;
                obj1.uuid=saved_object.uuid;
                let mat = saved_object.wts;
                obj1.applyMatrix4(mat);
                obj1.visible=saved_object.visible;    
                if (obj1.castShadow)
                {
                    obj1.shadow.camera.near = 100;
                    obj1.shadow.camera.far = 60000;
                    obj1.shadow.camera.right = 100000;
                    obj1.shadow.camera.left = - 100000;
                    obj1.shadow.camera.top	= 100000;
                    obj1.shadow.camera.bottom = - 100000;
                    obj1.shadow.mapSize.width = 1024;
                    obj1.shadow.mapSize.height = 1024;
                }
                resolve(obj1);
            } else if (saved_object.type=="PointLight"){

                let obj1 =  new THREE.PointLight(saved_object.color,1, 1000);
                obj1.intensity=saved_object.intensity;
                obj1.matrixWorldNeedsUpdate=true;
                obj1.name=saved_object.name;
                obj1.uuid=saved_object.uuid;
                let mat = saved_object.wts;
                obj1.applyMatrix4(mat);
                obj1.decay=saved_object.decay;
                obj1.distance=saved_object.distance;
                obj1.visible=saved_object.visible;   
                if (obj1.castShadow)
                {
                    obj1.shadow.camera.near = 100;
                    obj1.shadow.camera.far = 60000;
                    obj1.shadow.bias = 0.0001;
                    obj1.shadow.mapSize.width = 1024;
                    obj1.shadow.mapSize.height = 1024;
                } 
                resolve(obj1);
            }
            else if (saved_object.type=="SpotLight"){
                let obj1 =  new THREE.SpotLight(saved_object.color);
                obj1.intensity=saved_object.intensity;
                obj1.matrixWorldNeedsUpdate=true;
                obj1.name=saved_object.name;
                obj1.uuid=saved_object.uuid;
                let mat = saved_object.wts;
                obj1.applyMatrix4(mat);
                obj1.decay=saved_object.decay;
                obj1.decay=saved_object.decay;
                obj1.distance=saved_object.distance;
                obj1.angle=saved_object.angle;
                obj1.visible=saved_object.visible;    
                obj1.castShadow=saved_object.castShadow;
                if (obj1.castShadow)
                {
                    obj1.shadow.camera.near = 100;
                    obj1.shadow.camera.far = 60000;
                    obj1.shadow.bias = 0.0001;
                    obj1.shadow.mapSize.width = 1024;
                    obj1.shadow.mapSize.height = 1024;
                }
                obj1.target_uuid = saved_object.target_uuid;
                resolve(obj1);
            }
            else if (saved_object.type=="Reflector"){
                let geometry;
                geometry =  new THREE.PlaneGeometry( 1000, 1000 );
                let  obj = new Reflector( geometry, {
                    clipBias: 0.003,
                    textureWidth: o2.WIDTH,
                    textureHeight: o2.HEIGHT,
                    color: 0xffffff
                } );
                obj.matrixWorldNeedsUpdate=true;
                obj.name=saved_object.name;
                obj.uuid=saved_object.uuid;
                let mat = saved_object.wts;
                obj.applyMatrix4(mat);
                obj.visible=saved_object.visible;                
                resolve(obj);
            }
            else{
                resolve(null);
            }
        });     
    }

    load_mesh_url = (mdl_url,model_obj) =>
    {
        return new Promise((resolve,reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open("get", mdl_url, true);
            xhr.responseType = "arraybuffer";
            let o2 = this;
            xhr.send();
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        var xxx = xhr.response;
                        let p = o2.load_mesh(xxx,model_obj);
                        p.then((val)=>{
                            resolve(xhr.response);
                        });
                    }
                    else {
                        reject(xhr.status);
                    }
                }
            }    
        });     
    }

    _process_after_load=(object)=>
    {
        if (object.type=="SpotLight")
        {
            if (object.target_uuid)
            {
                let obj=this.search_obj_by_guid2(object.target_uuid);
                if (obj)
                {
                    object.target=obj;
                }
            }
        }
        //////////////
        for (let i = 0; i < object.children.length; i++) {
            this._process_after_load(object.children[i]);
        }
    }

    process_after_load=()=>
    {
        for (let i=0;i<this.scene.children.length;i++)
        {
            this._process_after_load(this.scene.children[i]);
        }
    }

    load_model=(mdl_url)=>
    {
        var xhr = new XMLHttpRequest();
        xhr.open("get", mdl_url, true);
        xhr.responseType = "json";
        var o2 = this;
        xhr.onload = function() {
            if(this.status == 200) {
                var model_obj = this.response;
                o2.load_mesh_url(model_obj["mesh"],model_obj);
            }
        }
        xhr.send();
    }

     reset_scene() {
        // scene
        //var JSZip = require("jszip");
        this.div_bind=[];
        this.cameras=[];
        this.script={};
        var scene=this.scene;
        this.scene.children=[];
        this.objects=[];
        this.materials=[];
        this.maps={};
        this.envmaps={};
        this.selection=null;
        this.import_root=null;
        //light
        // var ambientLight = new THREE.PointLight( 0xffffff, 1,1000 );
        // ambientLight.name="AmbientLight";
        // scene.add( ambientLight );
        scene.background = new THREE.Color(0xffffff);
        //grid
        var grid = new THREE.GridHelper( 10000, 10, 0xffffff, 0xffffff );
        grid.name="grid";
        grid.material.opacity = 0.3;
        grid.position.set(0,-40,0);
        grid.material.transparent=true;
        grid.visible=false;
        this.scene.add( grid );
        this.grid=grid;
        //env
        // var urls = [
        //     './static/textures/cube/Park2/posx.jpg', './static/textures/cube/Park2/negx.jpg',
        //     './static/textures/cube/Park2/posy.jpg', './static/textures/cube/Park2/negy.jpg',
        //     './static/textures/cube/Park2/posz.jpg', './static/textures/cube/Park2/negz.jpg'
        // ];
        // var reflectionCube = new THREE.CubeTextureLoader().load( urls );
        // reflectionCube.format = THREE.RGBFormat;
        scene.background = new THREE.Color(0,0,0);
        this.cubemap = null;
    }
    
    load_zip_scene = (url) => new Promise((resolve, reject) => 
    {
        this.project_url= url.substring(0,url.lastIndexOf('/')+1);
        if (!this.zip)
        {
            this.zip = new JSZip;
        }
        this.from_zip = true;
        this.all_files={};
        let o2=this;
        var on_unzipped = function()
        {
            console.log("解压完成，加载模型...");
            console.log(o2.all_files);
            if (o2.all_files["scene.json"]!=undefined)
            {
                var rt = o2.all_files["scene.json"];
                var xxx = JSON.parse(rt);
                /////////////////
                let obj = xxx.scene.background;
                if (obj.type==0)
                {
                    if (o2.scene.background.constructor==THREE.Color)
                    {
                        o2.scene.background.setHex(obj.color);
                    }else{
                        o2.scene.background=new THREE.Color();
                        o2.scene.background.setHex(obj.color);
                    }
                }
                if (obj.type==1)
                {
                    let map = o2.create_map(obj.map);
                    if (map != null) {
                        map.wrapS = THREE.RepeatWrapping;
                        map.wrapT = THREE.RepeatWrapping;
                        o2.scene.background = map;
                    }
                }
                if (obj.type==2)
                {
                    o2.scene.background = o2.create_envMap(obj.envMap);
                    o2.cubemap=o2.scene.background;
                }
                o2.animation.from_json(xxx.scene.animation);
                // /////
                const allRequest = [];            
                var mdls = xxx["children"];
                for (let index = 0; index < mdls.length; index++) {
                    const model_obj = mdls[index];
                    var promise = o2.load_saved_object(model_obj);
                    promise.then((obj3)=> {
                        if (obj3) o2.scene.add(obj3);
                    });
                    allRequest.push(promise);
                }
                if (o2.on_loading_msg)
                {
                    o2.on_loading_msg("加载完成");
                }
                if (o2.onload)
                {
                    o2.onload();
                    
                }
                
                Promise.all(allRequest).then(() => {
                    resolve();
                    o2.animation.bind_objects();
                    o2.process_after_load();
                    if (o2.script["init"])
                    {
                        o2.script["init"]();
                    }
                },() => {
                    reject()
                });
            }
        }
        // let script_url = this.project_url+"/script.js";
		// loadJs(script_url,function(){console.log('script load done');});
        var xhr = new XMLHttpRequest();
        xhr.open("get", url, true);
        xhr.responseType = "blob";
        xhr.addEventListener('progress', function (event) {
            // 响应头要有Content-Length
            if (event.lengthComputable) {
                let percentComplete = event.loaded / event.total;
                console.log(percentComplete); // 最后输出1
                    if (o2.on_loading_msg)
                    {
                        o2.on_loading_msg("正在下载:",String(Math.ceil(percentComplete*99)),"%");
                    }
                }
            }, false);
        xhr.onload = function() 
        {
            if(this.status == 200) {
                var xxx = this.response;
                o2.zip.loadAsync(xxx)
                .then(function(zip) {
                    console.log(zip);
                    var counts=0;
                    zip.forEach(function(v)
                    {
                        //console.log(v);  
                        counts++;
                        var type_read="arraybuffer";
                        if (v.substr(v.length-4,v.length)!="json")
                        {
                            //console.log(v);
                            type_read="arraybuffer";
                        }
                        if (v=="scene.json")
                        {
                            type_read="string";
                        }
                        o2.zip.file(v).async(type_read).then(function (content) 
                        {
                            //console.log(v,content);
                            o2.all_files[v]=content;
                            counts--;
                            if (counts==0)
                            {
                                on_unzipped();
                            }
                        });
                    });
                });
            }
        }
        xhr.send();
    })
    load_o2_scene = (url) => new Promise((resolve, reject) => {
        this.project_url= url.substring(0,url.lastIndexOf('/')+1);
        // let script_url = this.project_url+"/script.js";
		// loadJs(script_url,function(){console.log('script load done');});
        console.log(this.project_url);
        var xhr = new XMLHttpRequest();
        let o2=this;
        xhr.open("get", url, true);
        xhr.responseType = "text";
        xhr.send();

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 300) {
                    let aaa = xhr.response;
                    //console.log(aaa);
                    var xxx = JSON.parse(aaa);
                    if (xxx.type=="save_project")
                    {
                        /////
                        this.animation.from_json(xxx.scene.animation);
                        let obj = xxx.scene.background;
                        if (obj.type==0)
                        {
                            if (this.scene.background.constructor==THREE.Color)
                            {
                                this.scene.background.setHex(obj.color);
                            }else{
                                this.scene.background=new THREE.Color();
                                this.scene.background.setHex(obj.color);
                            }
                        }
                        if (obj.type==1)
                        {
                            let map = this.create_map(obj.map);
                            if (map != null) {
                                map.wrapS = THREE.RepeatWrapping;
                                map.wrapT = THREE.RepeatWrapping;
                                this.scene.background = map;
                            }
                        }
                        if (obj.type==2)
                        {
                            this.scene.background = this.create_envMap(obj.envMap);
                            this.cubemap=this.scene.background;
                        }
                        /////
                        const allRequest = [];            
                        var mdls = xxx["children"];
                        for (let index = 0; index < mdls.length; index++) {
                            const model_obj = mdls[index];
                            var promise = o2.load_saved_object(model_obj);
                            promise.then((obj3)=> {
                                if (obj3) o2.scene.add(obj3);
                            });
                            allRequest.push(promise);
                        }
                        Promise.all(allRequest).then(() => {
                            o2.animation.bind_objects();
                            o2.process_after_load();
                            if (o2.script["init"])
                            {
                                o2.script["init"]();
                            }
                            resolve();
                        },() => {
                            reject()
                        })
                    }else{
                        o2.scene.background = o2.create_envMap(xxx["evn"].cube);
                        o2.cubemap = o2.scene.background;

                        const allRequest = [];            
                        var mdls = xxx["models"];
                        for (let index = 0; index < mdls.length; index++) {
                            const model_obj = mdls[index];
                            allRequest.push(o2.load_mesh_url(o2.project_url+model_obj["mesh"],model_obj));
                        }
                        Promise.all(allRequest).then(() => {
                             o2.animation.bind_objects();
                             o2.process_after_load();
                            if (o2.script["init"])
                            {
                                o2.script["init"]();
                            }
                            resolve();
                        },() => {
                            reject()
                        })
                    }
                }
                else {
                    reject(xhr.status);
                }
            }
        }
    })

    import_url = (url) => new Promise((resolve, reject) => {
        this.project_url= url.substring(0,url.lastIndexOf('/')+1);
        console.log(this.project_url);
        var xhr = new XMLHttpRequest();
        let o2=this;
        xhr.open("get", url, true);
        xhr.responseType = "text";
        xhr.send();
        let import_root = new THREE.Object3D;
        import_root.name="import";
        this.scene.add(import_root);
        this.import_root=import_root;

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 300) {
                    let aaa = xhr.response;
                    console.log(aaa);
                    var xxx = JSON.parse(aaa);
                    if (xxx.type=="save_project")
                    {
                        /////
                        this.animation.from_json(xxx.scene.animation);
                        let obj = xxx.scene.background;
                        if (obj.type==0)
                        {
                            if (this.scene.background.constructor==THREE.Color)
                            {
                                this.scene.background.setHex(obj.color);
                            }else{
                                this.scene.background=new THREE.Color();
                                this.scene.background.setHex(obj.color);
                            }
                        }
                        if (obj.type==1)
                        {
                            let map = this.create_map(obj.map);
                            if (map != null) {
                                map.wrapS = THREE.RepeatWrapping;
                                map.wrapT = THREE.RepeatWrapping;
                                this.scene.background = map;
                            }
                        }
                        if (obj.type==2)
                        {
                            this.scene.background = this.create_envMap(obj.envMap);
                            this.cubemap=this.scene.background;
                        }
                        /////
                        const allRequest = [];            
                        var mdls = xxx["children"];
                        for (let index = 0; index < mdls.length; index++) {
                            const model_obj = mdls[index];
                            var promise = o2.load_saved_object(model_obj);
                            promise.then((obj3)=> {
                                if (obj3) import_root.add(obj3);
                            });
                            allRequest.push(promise);
                        }
                        Promise.all(allRequest).then(() => {
                            o2.animation.bind_objects();
                            if (o2.script["init"])
                            {
                                o2.script["init"]();
                            }
                            resolve();
                        },() => {
                            reject()
                        })
                    }else{
                        const allRequest = [];            
                        var mdls = xxx["models"];
                        for (let index = 0; index < mdls.length; index++) {
                            const model_obj = mdls[index];
                            allRequest.push(o2.load_mesh_url(o2.project_url+model_obj["mesh"],model_obj));
                        }
                        Promise.all(allRequest).then(() => {
                             o2.animation.bind_objects();
                            if (o2.script["init"])
                            {
                                o2.script["init"]();
                            }
                            resolve();
                        },() => {
                            reject()
                        })
                    }
                }
                else {
                    reject(xhr.status);
                }
            }
        }
    })

    create_envMap=(evn)=>
    {
        if (undefined==evn)
        {
            return this.cubemap;
        }
        let map = this.envmaps[evn];
        if (map==null)
        {
            if (this.from_zip)
            {
                let o2=this;
                var urls2=[];
                var urls = [
                    "image/"+evn+'/posx.jpg',
                    "image/"+evn+'/negx.jpg',
                    "image/"+evn+'/posy.jpg',
                    "image/"+evn+'/negy.jpg',
                    "image/"+evn+'/posz.jpg',
                    "image/"+evn+'/negz.jpg'
                ];
                for (let i=0;i<6;i++)
                {
                    let fnn = urls[i];
                    let f1 = this.all_files[fnn];
                    let blob = new Blob([f1], {type: "image/jpg"})
                    let url=URL.createObjectURL(blob);
                    urls2.push(url);
                }
                map = new THREE.CubeTextureLoader().load( urls2 );
            }else{

                let o2=this;
                var urls = [
                    o2.project_url+"image/"+evn+'/posx.jpg',
                    o2.project_url+"image/"+evn+'/negx.jpg',
                    o2.project_url+"image/"+evn+'/posy.jpg',
                    o2.project_url+"image/"+evn+'/negy.jpg',
                    o2.project_url+"image/"+evn+'/posz.jpg',
                    o2.project_url+"image/"+evn+'/negz.jpg'
                ];
                map = new THREE.CubeTextureLoader().load( urls );
            }
            map.cubename=evn;
            map.format = THREE.RGBFormat;
            this.envmaps[evn]=map;
        }
        if (map==null)
        {
            map=this.cubemap;
        }
        return map;
    }
    create_map=(map_url)=>
    {
        if (map_url=="") return null;
        if (this.from_zip)
        {
            let fnn = map_url;
            let f1 = this.all_files[fnn];
            let blob = new Blob([f1], {type: "image/jpg"})
            let url=URL.createObjectURL(blob);
            let map = new THREE.TextureLoader().load(url);
            map.name=map_url;
            
            map.wrapS = THREE.RepeatWrapping;
            map.wrapT = THREE.RepeatWrapping;
            return map;
        }
        let url=this.project_url+map_url;
        let map = new THREE.TextureLoader().load( url);
        map.name=map_url;
        map.wrapS = THREE.RepeatWrapping;
        map.wrapT = THREE.RepeatWrapping;
        return map;
    }

    init(container) {
        this.last_time=Date.now();
        this.container = container; //document.getElementById( 'container' );
		var WIDTH = this.container.clientWidth;
        var HEIGHT = this.container.clientHeight;
        this.WIDTH = WIDTH;
        this.HEIGHT = HEIGHT;
        this.maps={};
        this.copy_maps=[];
        //
       // let map = new THREE.TextureLoader().load( './static/textures/white.png' );
        let map = new THREE.TextureLoader().load( require('../images/white.png') );
        map.wrapS = THREE.RepeatWrapping;
        map.wrapT = THREE.RepeatWrapping;
        map.filpX=false;
        map.filpY=false;
        map.needsUpdate =true;
        this.map_white=map;
        // renderer
        this.renderer = new THREE.WebGLRenderer({antialias:true,
            alpha:true});
        this.renderer.setPixelRatio( window.devicePixelRatio );
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        this.renderer.setSize( WIDTH, HEIGHT );
        //scene
        var scene = new THREE.Scene();
        this.scene=scene;
        // camera
        var VIEW_ANGLE = 60;
        var ASPECT = this.WIDTH / this.HEIGHT;
        var NEAR = 100;
        var FAR = 500000;
        this.camera = new THREE.PerspectiveCamera( VIEW_ANGLE, ASPECT, NEAR, FAR );
        this.camera.position.set( 0, 3000, -5000 );
        // camera control
        this.cameraControls = new OrbitControls( this.camera, this.renderer.domElement );
        this.cameraControls.target.set( 0, 0, 0 );
        this.cameraControls.enableZoom = true;
        this.cameraControls.enableDamping = true;
        this.cameraControls.rotateSpeed = 1;
        this.cameraControls.minDistance = 100;
        this.cameraControls.maxDistance = 500000;
        this.cameraControls.maxPolarAngle=Math.PI/2-Math.PI/15;
        this.cameraControls.update();
        
        // reset scene
        this.reset_scene();
        // ///////////////////////
        // // composer
        // let composer = new EffectComposer( this.renderer );
        // this.composer=composer;
        // const renderPass = new RenderPass( this.scene, this.camera );
        // composer.addPass( renderPass );

        // var outlinePass = new OutlinePass( new THREE.Vector2( WIDTH,HEIGHT ), this.scene, this.camera );
        // this.outlinePass=outlinePass;
        // composer.addPass( outlinePass );
        // console.log(outlinePass);
        // outlinePass.visibleEdgeColor=new THREE.Color(1,1,0);
        // outlinePass.hiddenEdgeColor=new THREE.Color(0.5,0.5,0);
        // let map2 = new THREE.TextureLoader().load( './static/textures/tri_pattern.jpg' );
        // map2.wrapS = THREE.RepeatWrapping;
        // map2.wrapT = THREE.RepeatWrapping;
        // outlinePass.patternTexture = map2;

        // var effectFXAA = new ShaderPass( FXAAShader );
        // effectFXAA.uniforms[ 'resolution' ].value.set( 1 / WIDTH, 1 / HEIGHT );
        // composer.addPass( effectFXAA );
        // this.effectFXAA=effectFXAA;

        //FINAL
        this.container.appendChild( this.renderer.domElement );
        window.addEventListener('resize', this.onWindowResize, false);
        this.animate();
    }
    
    render=()=>
     {
       //this.composer.render();
       this.renderer.render( this.scene, this.camera );
    }

    onWindowResize=()=> {
		var WIDTH = this.container.clientWidth;
        var HEIGHT = this.container.clientHeight;
        this.camera.aspect = WIDTH /HEIGHT;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(WIDTH, HEIGHT);
    }
    add_empty_object=()=> {
        var obj = new THREE.Object3D();
        obj.name="Object";
        this.scene.add(obj);
    }
    load_mesh2 = (xxx) =>
    {
        var intarray = new Uint32Array(xxx,0,5);
        var num_faces=intarray[0];
        var num_pos=intarray[1];
        var num_nor=intarray[2];
        var num_uv=intarray[3];
        var num_uv2=intarray[4];
        var limits1 = new Float32Array(xxx,20,20);
        var posmin=[];
        var posmax=[];
        var posstep=[];
        posmin[0] = limits1[0];
        posmin[1] = limits1[1];
        posmin[2] = limits1[2];
        posmax[0] = limits1[3];
        posmax[1] = limits1[4];
        posmax[2] = limits1[5];
        posstep[0] = (posmax[0]-posmin[0])/65535;
        posstep[1] = (posmax[1]-posmin[1])/65535;
        posstep[2] = (posmax[2]-posmin[2])/65535;

        var normin=[];
        var normax=[];
        var norstep=[];
        normin[0] = limits1[6];
        normin[1] = limits1[7];
        normin[2] = limits1[8];
        normax[0]= limits1[9];
        normax[1] = limits1[10];
        normax[2] = limits1[11];
        norstep[0] = (normax[0]-normin[0])/65535;
        norstep[1] = (normax[1]-normin[1])/65535;
        norstep[2] = (normax[2]-normin[2])/65535;

        var uvmin=[];
        var uvmax=[];
        var uvstep=[];
        uvmin[0] = limits1[12];
        uvmin[1] = limits1[13];
        uvmax[0] = limits1[14];
        uvmax[1] = limits1[15];
        uvstep[0] = (uvmax[0]-uvmin[0])/65535;
        uvstep[1] = (uvmax[1]-uvmin[1])/65535;

        var uv2min=[];
        var uv2max=[];
        var uv2step=[];
        uv2min[0] = limits1[16];
        uv2min[1] = limits1[17];
        uv2max[0] = limits1[18];
        uv2max[1] = limits1[19];
        uv2step[0] = (uv2max[0]-uv2min[0])/65535;
        uv2step[1] = (uv2max[1]-uv2min[1])/65535;
        var ppos = new Float32Array(num_pos*3);
        var pnor = new Float32Array(num_pos*3);
        var puv = new Float32Array(num_pos*2);
        var puv2 = new Float32Array(num_pos*2);
        //console.log(model_json);
        var a1 = new Uint16Array(xxx,100,num_pos*3);
        var a2 = new Uint16Array(xxx,100+num_pos*6,num_nor*3);
        var a3 = new Uint16Array(xxx,100+num_pos*6+num_nor*6,num_uv*2);
        var a4 = new Uint16Array(xxx,100+num_pos*6+num_nor*6+num_uv*4,num_uv2*2);
        var pfaces = new Uint16Array(xxx,100+num_pos*6+num_nor*6+num_uv*4+num_uv2*4,num_faces*3);
        for (var i=0;i<a1.length;i++)
        {
            var idx = i%3;
            ppos[i]=posmin[idx]+a1[i]*posstep[idx];
        }
        var snor=[];
        snor[0]=0;
        snor[1]=1;
        snor[2]=0;
        for (var i=0;i<a1.length;i++)
        {
            var idx = i%3;
        pnor[i]=normin[idx]+a2[i]*norstep[idx];
        }
        for (var i=0;i<a3.length;i++)
        {
            var idx = i%2;
            puv[i]=uvmin[idx]+a3[i]*uvstep[idx];
            // puv[i]=a3[i];
        }
        for (var i=0;i<a4.length;i++)
        {
            var idx = i%2;
            puv2[i]=uv2min[idx]+a4[i]*uv2step[idx];
            // puv2[i]=a4[i];
        }
            
        var geometry = new THREE.BufferGeometry();
        geometry.setAttribute( 'position', new THREE.BufferAttribute( ppos, 3 ) );
        if (pnor.length>0) geometry.setAttribute( 'normal', new THREE.BufferAttribute( pnor, 3 ) );
        if (puv.length>0) geometry.setAttribute( 'uv', new THREE.BufferAttribute( puv, 2 ) );
        if (puv2.length>0) geometry.setAttribute( 'uv2', new THREE.BufferAttribute( puv2, 2 ) );
        var ba = new THREE.BufferAttribute(pfaces,1,true);
        geometry.setIndex(ba);
        geometry.computeBoundingBox();
        return geometry;
    }
    load_mesh = (bb,model_obj) => 
    {
        return new Promise((resolve,reject) => {
            var xxx = bb;
            if (xxx==undefined)
            {
                reject();
            }
            var o2=this;
            let geometry = this.load_mesh2(xxx);
            geometry.meshid=model_obj["mesh"];
            let map = o2.map_white;
        if (model_obj.mtl&&model_obj.mtl.map&&model_obj.mtl.map.image&&model_obj.mtl.map.image!="")
            {
            map = o2.create_map(model_obj.mtl.map.image); 
                map.wrapS = THREE.RepeatWrapping;
                map.wrapT = THREE.RepeatWrapping;
                map.repeat.set(model_obj.mtl.map.repeat[0],model_obj.mtl.map.repeat[1]);
                map.offset.set(model_obj.mtl.map.offset[0],-model_obj.mtl.map.offset[1]);
                map.rotation=model_obj.mtl.map.rotation;
            }
        let map2 = o2.map_white;
        if (model_obj.bake_tex!="")
        {
            map2= o2.create_map(model_obj.bake_tex);
        }
            let material = new THREE.MeshPhongMaterial( { map: map,lightMap:map2} );
            material.o2id=model_obj.mtl.id;
            o2.materials.push({id:material.o2id,mtl:material});
            if (model_obj.cullMode==1)
            {
                material.side= THREE.BackSide ;
            } else if(model_obj.cullMode==2)
            {
                material.side= THREE.DoubleSide ;
            } else{
                material.side= THREE.FrontSide;
            }
            material.transparent=model_obj.mtl.transparent;
            material.alphaTest=model_obj.mtl.alpha_test;
            if (model_obj.mtl.transparent)
            {
                material.opacity=model_obj.mtl.alpha;
            }
            material.reflectivity=0;
            //material.envMap=o2.cubemap;
            material.envMap=o2.create_envMap(model_obj.mtl.envMap);

            material.color = new THREE.Color(model_obj.mtl.dif_color);
            //console.log(model_obj);
            //new THREE.MeshBasicMaterial( { color: 0xff0000 } )
            var mesh =  new THREE.Mesh(geometry,material);
            mesh.name=model_obj.name;
            mesh.uuid=model_obj.uuid;
            var mat = new THREE.Matrix4();
            mat.elements=model_obj.wts;
            mesh.applyMatrix4(mat);
            if (o2.import_root!=null)
            {
                o2.import_root.add(mesh);
            }else
            {
                o2.scene.add(mesh);
            }
            //return geometry;
            resolve(geometry);
        });    
    }

    // 单击事件
    // onSceneClick = event => {
    //     event.preventDefault();
    //     // var dx = downx - event.offsetX;
    //     // var dy = downy - event.offsetY;
    //     var dx = event.offsetX;
    //     var dy = event.offsetY;
    //     //if (Math.sqrt(dx * dx + dy * dy) > 4) return;
    //     this.mouse.x = (event.offsetX / this.WIDTH) * 2 - 1;
    //     this.mouse.y = - (event.offsetY / (this.HEIGHT)) * 2 + 1;
    //     this.mouse_down = this.mouse - this.mouse_down;
    //     this.removeEdgeLine();
    //     this.unhover_all();

    //     console.log('3333')
    //     console.log(this)
    //     console.log(event.offsetX)
    //     console.log(this.WIDTH)
        
    //     this.raycaster.setFromCamera(this.mouse, this.camera);
    //     //pick
    //     let allobjs = this.scene.children;
    //     var intersects = this.raycaster.intersectObjects(allobjs);
    //     console.log(intersects)
    //     if (intersects.length > 0) {
    //         console.log('picked')
    //         var obj = intersects[0].object;
    //         return obj;
    //     }
    // }

    getObjById = id => {
        if (this.scene.children == undefined || this.scene.children.length <= 0) {
            return null;
        }

        let array = this.scene.children;
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if (element.id == id) {
                return element;
            }
        }
    }
    bind_div_to_world = (posx,posy,posz,earthDiv) => {
        if (earthDiv)
        {
            let bind = {};
            bind.div = earthDiv;
            bind.type=0;
            bind.position = new THREE.Vector3(posx,posy,posz);
            o2.div_bind.push(bind);
        }
    }
    
    search_obj_by_guid2 = (uuid) => {
        for (let i=0;i<this.scene.children.length;i++)
        {
            var found = this.search_obj_by_guid(this.scene.children[i],uuid);
            if (found)
            {
                return found;
            }
        }
        return null;
    }
    search_obj_by_guid = (target, uuid) => {
        if (target.uuid == uuid) {
            return target;
        }
        for (let i = 0; i < target.children.length; i++) {
            var found = this.search_obj_by_guid(target.children[i], uuid);
            if (found) {
                return found;
            }
        }
        return null;
    }
    _search_obj_by_name = (target, name) => {
        if (target.name == name) {
            return target;
        }
        for (let i = 0; i < target.children.length; i++) {
            var found = this._search_obj_by_name(target.children[i], name);
            if (found) {
                return found;
            }
        }
        return null;
    }
    
    search_obj_by_name=(name)=>
    {
        for (let i=0;i<this.scene.children.length;i++)
        {
            var found = this._search_obj_by_name(this.scene.children[i],name);
            if (found)
            {
                return found;
            }
        }
        return null;
    }
}

export {o2vr};